module.exports = __webpack_public_path__ + "img/omo2.357dd6fb.png";